export default "__VITE_ASSET__CERK$F7s__"